import type { SVGProps } from "react";
export function SoundCloud(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      data-slot="icon"
      {...props}
    >
      <clipPath id="a">
        <path d="m1.33325 4.66663h13.3333v7.03704h-13.3333z" />
      </clipPath>
      <g clipPath="url(#a)">
        <path
          d="m1.33325 10.4402c0 .1574.05999.2764.17993.3571.11996.0807.24818.1092.38468.0856.12822-.0236.21818-.0669.2699-.1298.0517-.063.07756-.1673.07756-.3129v-1.71161c0-.12199-.04446-.22528-.1334-.30987-.08892-.0846-.1975-.1269-.32573-.1269-.12409 0-.2306.0423-.31953.1269-.08893.08459-.13341.18788-.13341.30987zm1.42702.7319c0 .1141.0424.1997.12719.2568.0848.057.19338.0856.32573.0856.1365 0 .24714-.0286.33194-.0856.08479-.0571.12719-.1427.12719-.2568v-3.9899c0-.11805-.04447-.21937-.13339-.30397-.08894-.08459-.19752-.12689-.32574-.12689-.12408 0-.2306.0423-.31952.12689-.08894.08461-.1334.18592-.1334.30397zm1.42082.1889c0 .1141.04343.1997.13029.2567.08686.0571.19854.0856.33505.0856.13235 0 .24093-.0285.32572-.0856.0848-.057.1272-.1426.1272-.2567v-3.6417c0-.12197-.04447-.22625-.13339-.31282-.08894-.08656-.19544-.12983-.31953-.12983-.12823 0-.23784.04327-.32883.12983-.091.08657-.1365.19085-.1365.31282v3.6417zm1.42701.0177c0 .2164.15304.3246.45913.3246.30608 0 .45912-.1082.45912-.3246v-5.90225c0-.33052-.10548-.51742-.31643-.56071-.1365-.03148-.27093.0059-.40329.11214s-.19854.25576-.19854.44857v5.90225zm1.45185.1712v-6.42168c0-.20461.06411-.32658.19234-.36594.27713-.06295.55219-.09443.82519-.09443.63284 0 1.22227.14165 1.76825.42496.54597.28331.98757.6699 1.32467 1.15979.3371.4899.5325 1.02994.5863 1.62017.2523-.10231.5212-.15346.8066-.15346.579 0 1.0744.19478 1.4859.58433.4116.38956.6174.85779.6174 1.40474 0 .55092-.2058 1.02112-.6174 1.41062-.4115.3896-.9048.5843-1.4797.5843l-5.39789-.0059c-.03724-.0118-.06516-.0334-.08377-.0649-.01862-.0315-.02789-.059-.02789-.0826z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
